import axios from "axios";
import { awsUrl } from "../../axiosInstance";
import * as actionType from "../store/action";
import { setPreload } from "../server/CartsOpen";

export const DeliveryHoursGet = (StationId) => {
  return axios.get(`${awsUrl}/v1/deliveryHours`, {
    headers: {
      Authorization: `bearer ${localStorage.jwtToken}`,
    },
  });
};

export const DeliveryHoursSetTime = (data) => {
  return (dispatch) => {
    dispatch(setPreload(true));
    axios
      .post(`${awsUrl}/v1/orders/deliveryHours`, data, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
        },
      })
      .then((x) => {
        if (x.data) {
          dispatch({
            type: actionType.SET_ORDER_TIME,
            payload: data.OrderTime,
          });
        } else {
          dispatch({ type: actionType.SET_ORDER_TIME, payload: null });
        }
      })
      .catch(() => console.log("error"))
      .finally(() => dispatch(setPreload(false)));
  };
};
